import classNames from 'classnames';
import { ComponentProps } from 'react';

import CleanButton from '../CleanButton/CleanButton';
import SVG from '../SVG/SVG';

import closeIcon from './graphics/close.svg?raw';

import styles from './CloseButton.module.css';

type CloseButtonProps = {
    variant?: 'default' | 'brand' | 'clear' | 'white-with-shadow';
    size?: 'small' | 'medium' | 'large';
} & Omit<ComponentProps<typeof CleanButton>, 'children'>;

const CloseButton = ({
    className,
    disabled,
    variant = 'default',
    size = 'medium',
    ...buttonProps
}: CloseButtonProps) => {
    const classes = classNames(className, styles.Root, {
        [styles.disabled]: disabled,
        [styles.styleDefault]: variant === 'default',
        [styles.styleBrand]: variant === 'brand',
        [styles.styleClear]: variant === 'clear',
        [styles.styleWhiteWithShadow]: variant === 'white-with-shadow',
        [styles.sizeSmall]: size === 'small',
        [styles.sizeMedium]: size === 'medium',
        [styles.sizeLarge]: size === 'large',
    });

    const iconClasses = classNames({
        [styles.Icon_sizeSmall]: size === 'small',
        [styles.Icon_sizeMedium]: size === 'medium',
        [styles.Icon_sizeLarge]: size === 'large',
    });

    return (
        <CleanButton
            {...buttonProps}
            disabled={disabled}
            className={classes}
            aria-label="Close"
        >
            <SVG src={closeIcon} className={iconClasses} />
        </CleanButton>
    );
};

export default CloseButton;
